import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import {
  columnStateChangedEpic,
  fetchColumnDefinitionReceivedEpic,
  loadPreferenceStateEpic,
  pageSizeChangedEpic,
  persistPreferenceStateEpic,
} from './preferenceState/preferenceStateEpics';
import {
  fetchColumnDefinitionEpic,
  fetchItemsEpic,
  loadFilters,
  persistFilters,
  pollSecondaryMarketBlotterItemsEpic,
} from './secondaryMarketTradeBlotterEpics';

export const secondaryMarketTradeBlotterEpic = () =>
  withAppCrashIfException(
    'secondaryMarketTradeBlotter',
    combineEpics(
      columnStateChangedEpic(),
      fetchColumnDefinitionEpic(),
      fetchColumnDefinitionReceivedEpic(),
      fetchItemsEpic(),
      loadFilters(),
      loadPreferenceStateEpic(),
      pageSizeChangedEpic(),
      persistFilters(),
      persistPreferenceStateEpic(),
      pollSecondaryMarketBlotterItemsEpic(),
    ),
  );
